import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditEventTopicPayload } from '@app-store/slices/eventTopics/editEventTopic'

interface TaskAction extends Action {
    payload: IEditEventTopicPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventTopics.edit

function* editEventTopicSagaTask({ payload }) {
    try {
        const response = yield axios.patch(`/event/event-topic/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editEventTopicSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editEventTopicSagaTask)
}

export default editEventTopicSaga
